import { InboundEmailsPermissions } from './inbound-emails.permissions';
import { InboundEmailsRoles } from './inbound-emails.roles';

export const inboundEmailsMappings = {
  [InboundEmailsPermissions.GET_INBOUND_EMAILS]: [InboundEmailsRoles.MANAGER],
  [InboundEmailsPermissions.MANAGE_INBOUND_EMAILS]: [
    InboundEmailsRoles.MANAGER,
  ],
};
